import * as actionTypes from './actionTypes';
import HttpClient from "../../_services/httpClient";
import axios from 'axios';
import {finishLoading, startLoading, setError} from "./uiActions";
import {savePartnerID} from "./repositoryDataActions";

const instance = axios.create();
instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;

export const userLogin = (user) => {
    return (dispatch) => {

        dispatch(startLoading());

        return new Promise((resolve, eject) => {
            instance.post("/user/login", user)
                .then(response => {
                    sessionStorage.setItem('token_security', response.data.token);
                    sessionStorage.setItem('redirect_to_login', "true");
                    dispatch( finishLoading());
                    dispatch( userLoginSuccess(response.data))
                    dispatch(savePartnerID(parseInt(response.data.PartnerId)));

                    resolve(response);
                })
                .catch((error) => {
                    dispatch( finishLoading());
                    dispatch( setError(error.response?.data?.errors?.message ?? error.message));

                    eject(error);
                })
        });
    }
};

export const getCurrentUser = () => {
    return (dispatch) => {

        dispatch(startLoading());

        return new Promise((resolve, eject) => {
            HttpClient.get('/user')
                .then(response => {
                    dispatch( finishLoading());
                    dispatch(userLoginSuccess(response.data))
                    dispatch(savePartnerID(parseInt(response.data.partnerId)));

                    resolve(response);
                })
                .catch((error) => {
                    dispatch( finishLoading());
                    eject(error);
                })
        });
    }
}

const userLoginSuccess = (data) => {
    const redirect = sessionStorage.getItem('redirect_to_login') === 'true'? true: false
    return {
        type: actionTypes.OPEN_SESSION,
        data: data,
        authenticated: true,
        redirectOn: redirect,
    }
}

export const userRegister = (user) => {
    return (dispatch) => {

        dispatch(startLoading());

        return new Promise((resolve, eject) => {
            instance.post("/user/register", user)
                .then(response => {
                    sessionStorage.setItem('token_security', response.data.token);
                    dispatch( finishLoading());
                    dispatch(userRegisterSuccess(response.data));

                    resolve(response);
                })
                .catch(error => {
                    dispatch( finishLoading());
                    dispatch( setError(error.response?.data?.errors?.message ?? 'User could not be registered!'));
                    eject(error);
                })
        });
    }
}

const userRegisterSuccess = (data) => {
    return {
        type: actionTypes.CREATE_SESSION,
        data: data,
        authenticated: false,
    }
}

export const userLogout = () => {
    return (dispatch) => {
        sessionStorage.removeItem('token_security');
        dispatch(userLogoutSuccess());
    }
}

const userLogoutSuccess = () => {
    return {
        type: actionTypes.CLOSE_SESSION,
        data: null,
        authenticated: false,
    }
}